import {AvatarInput} from '@/components/refinedev/AvatarInput';
import CheckboxInput from '@/components/refinedev/CheckboxInput';
import SelectInput from '@/components/refinedev/SelectInput';
import TextInput from '@/components/refinedev/TextInput';
import Section from '@/components/surface/Section';
import {useDepartmentList, useJobList} from 'pages/_utils';

const StaffForm = () => {
  const getDepartmentListResult = useDepartmentList();
  const getJobListResult = useJobList();

  return (
    <Section title="Nhân viên" subtitle="Nhập thông tin của nhân viên">
      <AvatarInput source="avatar" label="Ảnh đại diện" />
      <TextInput source="name" label="Họ và tên" />
      <SelectInput
        source="department_id"
        label="Phòng ban"
        optionText="name"
        choices={getDepartmentListResult.data?.data || []}
      />
      <SelectInput
        source="job_id"
        label="Công việc"
        optionText="title"
        choices={getJobListResult.data?.data || []}
      />
    </Section>
  );
};

export const transformBeforeSave = data => {
  return data;
};

StaffForm.transformBeforeSave = transformBeforeSave;

export default StaffForm;
